var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactionBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.73329 14L4.46663 11.8667L2.06663 11.3333L2.29996 8.86667L0.666626 7L2.29996 5.13333L2.06663 2.66667L4.46663 2.13333L5.73329 0L7.99996 0.966667L10.2666 0L11.5333 2.13333L13.9333 2.66667L13.7 5.13333L15.3333 7L13.7 8.86667L13.9333 11.3333L11.5333 11.8667L10.2666 14L7.99996 13.0333L5.73329 14ZM7.29996 9.36667L11.0666 5.6L10.1333 4.63333L7.29996 7.46667L5.86663 6.06667L4.93329 7L7.29996 9.36667Z",
    fill: "#374DA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionBadge);
export default __webpack_public_path__ + "static/media/TransactionBadge.509c5dedf8f8d5b2eb4c830b398d8a4f.svg";
export { ForwardRef as ReactComponent };